<div class="d-inline-block right">
<button type="button" class="btn-close btn-close-white px-2" aria-label="Close" (click)="closeDialog()"></button>
</div>
<div class="payment_wrapper">
  <ng-container *ngIf="!finishedPaying || paymentMethod == paymentMethodEnum.Card">
      <div class="payment_h">{{'ORDER.ORDER' | translate}} #{{orderBillNumber}}</div>
      <div class="payment_h2">{{totalPriceWithTax | customCurrencyPipe: currencyShortName :'1.0-2'}}</div>
    </ng-container>

    <ng-container *ngIf="!paymentMethod">
        <button class="payment_btn" (click)="choosePaymentMethod(paymentMethodEnum.Cash)"><i class="pi pi-money-bill"></i> {{'ORDER_BILL.CASH' | translate}}</button>
        <button class="payment_btn" (click)="choosePaymentMethod(paymentMethodEnum.Card)"><i class="pi pi-credit-card"></i> {{'ORDER_BILL.CARD' | translate}}</button>
    </ng-container>

    <ng-container *ngIf="paymentMethod == paymentMethodEnum.Cash">
      <div *ngIf="!finishedPaying" class="d-flex flex-column justify-content-start">
        <label class="d-block">{{'ORDER_BILL.TENDER_AMOUNT' | translate}}</label>
        <input class="cash_input" type="number" [(ngModel)]="tenderAmount">
        <button class="payment_btn w-100" (click)="finishPaying()" [disabled]="!tenderAmount || tenderAmount < totalPriceWithTax">{{'FINISH' | translate}}</button>
      </div>
      <ng-container *ngIf="finishedPaying">
        <label class="d-block payment_h">{{'ORDER_BILL.CHANGE_DUE' | translate}}</label>
        <span class="d-block payment_h2">{{toReturn | customCurrencyPipe: currencyShortName :'1.0-2'}}</span>
        <button class="payment_btn" (click)="closeDialog()">{{'OK' | translate | uppercase}}</button>
      </ng-container>

    </ng-container>

    <ng-container *ngIf="paymentMethod == paymentMethodEnum.Card">
      <ng-container *ngIf="!finishedPaying">
        <button class="payment_btn" (click)="finishPaying()">{{'FINISH' | translate}}</button>
      </ng-container>
      <ng-container *ngIf="finishedPaying">
        <button class="payment_btn" (click)="closeDialog()">{{'OK' | translate | uppercase}}</button>
      </ng-container>
    </ng-container>

</div>



